// extracted by mini-css-extract-plugin
export var closeButton = "useModal-module--closeButton--db07f";
export var closing = "useModal-module--closing--e383f";
export var fadeIn = "useModal-module--fade-in--f8368";
export var fadeOut = "useModal-module--fade-out--03462";
export var modal = "useModal-module--modal--2fb2c";
export var noScroll = "useModal-module--no-scroll--5075e";
export var overlay = "useModal-module--overlay--37911";